import { useId, type ReactNode } from 'react';

/**
 * Handritade elprylar bakom inloggningen – det El-kretsen samlar in och
 * återvinner: hushållsapparater, ljuskällor, batterier, småelektronik och
 * vägen dit (kärl, lastbil, kretslopp). Ritade i 64 × 64; ett gemensamt
 * förskjutningsfilter gör strecken lite darriga, som tuschpenna.
 */
const PRYLAR: Record<string, ReactNode> = {
  lampa: (
    <>
      <path d="M24 40c-4-4-8-8-8-15a16 16 0 0 1 32 0c0 7-4 11-8 15v4H24z" />
      <path d="M25 48h14M27 52h10" />
      <path d="M28 40l2-12 2 4 2-4 2 12" />
    </>
  ),
  kyl: (
    <>
      <rect x="18" y="6" width="28" height="52" rx="3" />
      <path d="M18 24h28" />
      <path d="M24 13v6M24 30v10" />
      <path d="M22 58v2M42 58v2" />
    </>
  ),
  batteri: (
    <>
      <rect x="22" y="14" width="20" height="42" rx="3" />
      <path d="M28 10h8v4h-8z" />
      <path d="M32 24v8M28 28h8M28 46h8" />
    </>
  ),
  horlurar: (
    <>
      <path d="M12 38v-6a20 20 0 0 1 40 0v6" />
      <rect x="8" y="36" width="10" height="16" rx="4" />
      <rect x="46" y="36" width="10" height="16" rx="4" />
    </>
  ),
  dammsugare: (
    <>
      <path d="M6 52v-4a10 10 0 0 1 10-10h10a8 8 0 0 1 8 8v6z" />
      <circle cx="13" cy="54" r="3" />
      <circle cx="28" cy="54" r="3" />
      <path d="M34 46c8 0 9-8 12-14s6-8 10-8" />
      <path d="M56 24l-6 28" />
      <path d="M42 54h14" />
    </>
  ),
  brodrost: (
    <>
      <path d="M8 30a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v20H8z" />
      <path d="M20 22v-8a4 4 0 0 1 8 0v8" />
      <path d="M36 22v-5" />
      <path d="M50 34h6v4" />
      <path d="M12 54h4M48 54h4" />
    </>
  ),
  mobil: (
    <>
      <rect x="20" y="6" width="24" height="50" rx="4" />
      <path d="M28 11h8" />
      <circle cx="32" cy="50" r="2" />
    </>
  ),
  kontakt: (
    <>
      <rect x="20" y="20" width="24" height="18" rx="5" />
      <path d="M27 20v-8M37 20v-8" />
      <path d="M32 38v6c0 8-8 8-8 16" />
    </>
  ),
  laptop: (
    <>
      <rect x="12" y="14" width="40" height="26" rx="2" />
      <path d="M6 44h52l-4 6H10z" />
      <path d="M28 47h8" />
    </>
  ),
  tv: (
    <>
      <rect x="8" y="14" width="48" height="32" rx="3" />
      <path d="M24 46l-4 8M40 46l4 8" />
      <path d="M26 6l6 8 6-8" />
    </>
  ),
  tvattmaskin: (
    <>
      <rect x="12" y="6" width="40" height="52" rx="3" />
      <path d="M12 18h40" />
      <circle cx="32" cy="38" r="12" />
      <path d="M25 40c3 3 11 3 14-2" />
      <path d="M18 12h6" />
      <circle cx="44" cy="12" r="1.5" />
    </>
  ),
  mikro: (
    <>
      <rect x="6" y="16" width="52" height="32" rx="3" />
      <rect x="11" y="21" width="30" height="22" rx="2" />
      <path d="M48 22v4" />
      <circle cx="48" cy="33" r="1.5" />
      <circle cx="48" cy="39" r="1.5" />
    </>
  ),
  vattenkokare: (
    <>
      <path d="M20 54h26l-3-32H23z" />
      <path d="M43 26c8 0 10 4 10 11s-4 9-8 9" />
      <path d="M22 26l-8-6" />
      <path d="M25 22c0-5 16-5 16 0" />
      <path d="M16 58h34" />
    </>
  ),
  harfon: (
    <>
      <circle cx="24" cy="24" r="12" />
      <circle cx="24" cy="24" r="4" />
      <path d="M36 18h16v12H36" />
      <path d="M22 36l-4 20h8l2-20" />
      <path d="M56 20v8" />
    </>
  ),
  borr: (
    <>
      <path d="M8 18h34a6 6 0 0 1 0 12H8z" />
      <path d="M48 24h10M52 22l2 4" />
      <path d="M22 30l-4 18h10l2-18" />
      <path d="M14 48h20v8H14z" />
    </>
  ),
  lysror: (
    <>
      <rect x="6" y="20" width="52" height="8" rx="4" />
      <rect x="6" y="36" width="52" height="8" rx="4" />
      <path d="M12 20v8M52 20v8M12 36v8M52 36v8" />
      <path d="M2 24h4M58 24h4M2 40h4M58 40h4" />
    </>
  ),
  solpanel: (
    <>
      <path d="M10 18h40l6 26H16z" />
      <path d="M23 18l4 26M37 18l5 26M13 31h40" />
      <path d="M36 44v10M28 56h16" />
    </>
  ),
  sparkcykel: (
    <>
      <circle cx="12" cy="50" r="5" />
      <circle cx="52" cy="50" r="5" />
      <path d="M12 50h36" />
      <path d="M48 50l-8-38" />
      <path d="M34 12h12" />
    </>
  ),
  klocka: (
    <>
      <rect x="22" y="20" width="20" height="24" rx="5" />
      <path d="M26 20l2-12h8l2 12M26 44l2 12h8l2-12" />
      <path d="M32 27v6l3 3" />
    </>
  ),
  handkontroll: (
    <>
      <path d="M18 22h28c8 0 12 10 12 20 0 6-6 8-10 2l-4-6H20l-4 6c-4 6-10 4-10-2 0-10 4-20 12-20z" />
      <path d="M20 29v8M16 33h8" />
      <circle cx="42" cy="30" r="1.8" />
      <circle cx="47" cy="35" r="1.8" />
    </>
  ),
  kaffe: (
    <>
      <path d="M12 8h38v8H12z" />
      <path d="M44 16v40M12 56h40" />
      <path d="M18 34h18l-2 18H20z" />
      <path d="M36 38c5 0 5 9 0 9" />
      <path d="M27 18v8" />
    </>
  ),
  tandborste: (
    <>
      <path d="M28 58V26a4 4 0 0 1 8 0v32z" />
      <path d="M30 26V10h4v16" />
      <path d="M34 11h5M34 15h5M34 19h5" />
      <circle cx="32" cy="38" r="2" />
    </>
  ),
  kretskort: (
    <>
      <rect x="8" y="8" width="48" height="48" rx="3" />
      <rect x="24" y="24" width="16" height="16" rx="1" />
      <path d="M8 20h10l6 6M56 44H46l-6-6M20 56V44l4-4M44 8v12l-4 4" />
      <circle cx="14" cy="46" r="2" />
      <circle cx="50" cy="16" r="2" />
    </>
  ),
  grenuttag: (
    <>
      <rect x="6" y="38" width="40" height="14" rx="3" />
      <circle cx="16" cy="45" r="3" />
      <circle cx="30" cy="45" r="3" />
      <path d="M46 45c10 0 12-10 4-16s-6-18 6-22" />
    </>
  ),
  brandvarnare: (
    <>
      <circle cx="32" cy="32" r="20" />
      <circle cx="32" cy="32" r="11" />
      <circle cx="32" cy="32" r="2" />
      <path d="M44 14c3 2 5 4 6 7M50 10c4 3 7 6 8 10" />
    </>
  ),
  varmepump: (
    <>
      <rect x="6" y="14" width="52" height="36" rx="3" />
      <circle cx="22" cy="32" r="10" />
      <path d="M22 22v20M12 32h20" />
      <path d="M40 22h12M40 28h12M40 34h12M40 40h12" />
      <path d="M12 50v4M52 50v4" />
    </>
  ),
  kretslopp: (
    <>
      <path d="M50 22A20 20 0 1 0 52 38" />
      <path d="M42 20l8 2 2-8" />
      <path d="M24 32h14M32 26l6 6-6 6" />
    </>
  ),
  karl: (
    <>
      <path d="M12 14h40v5H12z" />
      <path d="M16 19h32l-4 35H20z" />
      <path d="M26 26v22M38 26v22" />
      <circle cx="22" cy="57" r="3" />
      <circle cx="42" cy="57" r="3" />
    </>
  ),
  lastbil: (
    <>
      <path d="M4 16h34v28H4z" />
      <path d="M38 24h12l8 10v10H38z" />
      <path d="M42 28h7l4 6H42z" />
      <circle cx="14" cy="46" r="5" />
      <circle cx="48" cy="46" r="5" />
    </>
  ),
  ficklampa: (
    <>
      <path d="M8 26h28v12H8z" />
      <path d="M36 22l10-6v32l-10-6z" />
      <path d="M52 24l8-4M52 32h8M52 40l8 4" />
      <path d="M18 26v-3h6v3" />
    </>
  ),
};

/**
 * Rutnät 7 × 6 över hela sidan. Mittkolumnerna (2–4) i raderna 1–4 hålls
 * tomma åt rubrik och kort – kvar blir exakt 30 rutor, en figur i varje.
 * Under sm syns bara översta och nedersta raden; resten hamnar bakom kortet.
 */
const KOLUMNER = 7;
const RADER = 6;
const RUTOR = Array.from({ length: KOLUMNER * RADER }, (_, i) => ({ kol: i % KOLUMNER, rad: Math.floor(i / KOLUMNER) })).filter(
  ({ kol, rad }) => !(kol >= 2 && kol <= 4 && rad >= 1 && rad <= 4),
);
const NAMN = Object.keys(PRYLAR);

/** Fast "slump" – samma utspridning vid varje laddning. */
const slump = (i: number, salt: number) => {
  const x = Math.sin(i * 12.9898 + salt * 78.233) * 43758.5453;
  return x - Math.floor(x);
};

export function PrylBakgrund() {
  const darr = `pryl-darr-${useId().replace(/:/g, '')}`;

  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden text-ink-300">
      <svg width="0" height="0" className="absolute">
        <filter id={darr}>
          <feTurbulence type="fractalNoise" baseFrequency="0.035" numOctaves="2" seed="7" />
          <feDisplacementMap in="SourceGraphic" scale="2.6" />
        </filter>
      </svg>
      {RUTOR.map(({ kol, rad }, i) => {
        const pryl = NAMN[i % NAMN.length];
        const x = ((kol + 0.5 + (slump(i, 1) - 0.5) * 0.5) / KOLUMNER) * 100;
        const y = ((rad + 0.5 + (slump(i, 2) - 0.5) * 0.45) / RADER) * 100;
        const vrid = Math.round((slump(i, 3) - 0.5) * 36);
        const storlek = 68 + Math.round(slump(i, 4) * 36);
        const mellan = rad >= 1 && rad <= 4;
        return (
          <svg
            key={pryl}
            viewBox="0 0 64 64"
            className={`absolute ${mellan ? 'hidden sm:block' : ''}`}
            style={{
              left: `${x}%`,
              top: `${y}%`,
              width: `clamp(44px, ${storlek / 13}vw, ${storlek}px)`,
              transform: `translate(-50%, -50%) rotate(${vrid}deg)`,
            }}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <g filter={`url(#${darr})`}>{PRYLAR[pryl]}</g>
          </svg>
        );
      })}
    </div>
  );
}
